import type { SelectOption } from 'ui/select/select';

import {
  type AnimationSettingResult,
  AnimationSettingsDialog
} from 'cadenza/conditions/actions/animation-settings-dialog';
import {
  TableSliderAnimationPreview
} from 'cadenza/conditions/table-slider-condition/table-slider-animation-preview';

import i18n from './table-slider-animation-settings-dialog.properties';
import type { TableConditionApi } from 'cadenza/api-client/conditions/table-condition-api';
import type { TableColumnsDto } from 'cadenza/ui/base-table/model/table-column-dto';

const COMPONENT_NAME = 'd-table-slider-animation-settings-dialog';

export interface TableSliderAnimationSettingsDialogOptions {
  rangeStart: SelectOption;
  rangeEnd: SelectOption;
  selectedStart: SelectOption;
  maxFrames: number;
  conditionApi: TableConditionApi;
  tableColumnsDef: TableColumnsDto;
}

export class TableSliderAnimationSettingsDialog extends AnimationSettingsDialog {

  readonly #options: TableSliderAnimationSettingsDialogOptions;
  readonly #preview: TableSliderAnimationPreview;

  constructor (options: TableSliderAnimationSettingsDialogOptions) {
    super();
    this.#options = options;
    this.#preview = this._createPreview();
    this.setLoading(this.#preview.dataLoadingPromise, { label: i18n('loadingData') });
  }

  createSpecificContent (): HTMLElement[] {
    return [ this.#preview ];
  }

  _createPreview (): TableSliderAnimationPreview {
    return new TableSliderAnimationPreview(
      this.#options.selectedStart,
      this.#options.rangeEnd,
      this.#options.maxFrames,
      this.#options.conditionApi,
      this.#options.tableColumnsDef);
  }

  override onSubmit () {
    const result: AnimationSettingResult = {
      type: 'table',
      viewId: this.selectedViewId,
      rangeStart: this.#preview.startIndex,
      rangeEnd: this.#preview.endIndex,
      sliderRangeStart: this.#options.rangeStart,
      sliderRangeEnd: this.#options.rangeEnd
    };
    this.close(result);
  }

}

customElements.define(COMPONENT_NAME, TableSliderAnimationSettingsDialog);
